<template>
  <!--  Pager -->
  <div class="row">
    <div class="col-6 text-nowrap">
      <label class="control-label fw-bold">
        {{ $t('label.results.show') }}
        <select
          v-model="perPage"
          data-optionality="required"
          class="form-control input-sm pager rounded-0 d-inline form-select"
        >
          <option value="5">5</option>
          <option
            selected="selected"
            value="15"
          >15</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
        {{ $tc('label.results.number', posts.length, { count: posts.length }) }}
      </label>
    </div>

    <div class="col-6">
      <ul class="pagination justify-content-end">
        <li class="page-item">
          <a
            class="page-link"
            href="#"
            @click="before(); $emit('page-update',displayedPosts);"
          >&laquo;</a>
        </li>

        <li
          v-for="pageNumber in pages"
          :key="pageNumber.id"
          class="page-item"
          @click="page = pageNumber; $emit('page-update',displayedPosts);"
        >
          <a
            class="page-link"
            href="#"
          >{{ pageNumber }}</a>
        </li>

        <li class="page-item">
          <a
            class="page-link"
            href="#"
            @click="next(); $emit('page-update',displayedPosts);"
          >
            &raquo;
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  props: {
    posts: Array
  },
  emits: ['page-update'],
  data () {
    return {
      page: 1,
      perPage: 15,
      pages: []
    }
  },

  methods: {
    setPages () {
      this.pages = []
      const numberOfPages = Math.ceil(this.posts.length / this.perPage)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },
    paginate (posts) {
      const page = this.page
      const perPage = this.perPage
      const from = page * perPage - perPage
      const to = page * perPage
      return posts.slice(from, to)
    },
    before () {
      if (this.page > 1) {
        this.page--
      }
    },
    next () {
      if (this.page < this.pages.length) {
        this.page++
      }
    }
  },

  computed: {
    displayedPosts () {
      return this.paginate(this.posts)
    }
  },

  watch: {
    posts: function () {
      this.setPages()
    },
    perPage: function () {
      this.page = 1
      this.setPages()
      this.$emit('page-update', this.displayedPosts)
    }
  },

  created () {
    this.$emit('page-update', this.displayedPosts)
    this.setPages()
  }
}
</script>
